// AI-CONTEXT: See docs/features/updates-log.md
// AI-CONTEXT: See docs/patterns.md#data-static-release-bound-list
// Bepaalt welke updates deze organisatie te zien krijgt, en in welke volgorde.

import isValidUpdate from './isValidUpdate'
import { ALWAYS_VISIBLE_MODULE, UPDATE_MODULE_SLUGS } from './updateModules'

/**
 * Filtert op de afgenomen modules en sorteert nieuwste eerst.
 *
 * Onbekende modules van de organisatie worden genegeerd, zodat een tikfout in
 * de aanroep de lijst niet stilletjes opent. Bij een gelijke datum bepaalt het
 * id de volgorde — anders verspringt de lijst zodra iemand een entry ergens
 * tussenvoegt in het bestand.
 *
 * @param {*} updates - De ruwe lijst uit updates.json
 * @param {Array<string>} [activeModules] - Modulecodes die de organisatie afneemt
 * @returns {Array<import('./isValidUpdate').Update>} Nieuwe, gesorteerde lijst
 */
const filterUpdates = (updates, activeModules) => {
    if (!Array.isArray(updates)) return []

    // 'algemeen' zit er altijd bij; de rest alleen als de organisatie hem echt
    // afneemt. Zonder bekende modules blijft er dus alleen 'algemeen' over —
    // de poort valt dicht, niet open.
    const zichtbaar = new Set([ALWAYS_VISIBLE_MODULE])
    if (Array.isArray(activeModules)) {
        activeModules
            .filter((slug) => UPDATE_MODULE_SLUGS.includes(slug))
            .forEach((slug) => zichtbaar.add(slug))
    }

    return updates
        .filter(isValidUpdate)
        .filter((update) => update.modules.some((slug) => zichtbaar.has(slug)))
        .sort((a, b) => (a.date === b.date ? a.id.localeCompare(b.id) : b.date.localeCompare(a.date)))
}

export default filterUpdates
